import Main from './Main'
import App from './App'
import Dashboard from './Dashboard'
import Page from './Page'

export default {
  components: {
    Main, App, Dashboard, Page
  }
}
